import { ComponentProps, Fragment, ReactNode } from 'react'
import {
  Tab as HeadlessUITab,
  TabGroup as HeadlessUITabGroup,
  TabList as HeadlessUITabList,
  TabPanels as HeadlessUITabPanels,
  TabPanel as HeadlessUITabPanel,
} from '@headlessui/react'

const TabGroup = (props: {
  children: ReactNode
  onChange?: (index: number) => void
  selectedIndex?: number
}) => {
  return <HeadlessUITabGroup as={Fragment} {...props} />
}

export default TabGroup

export const TabList = (props: ComponentProps<typeof HeadlessUITabList>) => {
  return <HeadlessUITabList className="grid grid-cols-2" {...props} />
}

export const Tab = (props: ComponentProps<typeof HeadlessUITab>) => {
  return (
    <HeadlessUITab
      className="border-b border-grey-3 transition-colors focus-visible:outline-none data-[selected]:text-orange-2"
      {...props}
    />
  )
}

export const TabPanels = (
  props: ComponentProps<typeof HeadlessUITabPanels>,
) => {
  return <HeadlessUITabPanels {...props} />
}

export const TabPanel = (props: ComponentProps<typeof HeadlessUITabPanel>) => {
  return <HeadlessUITabPanel {...props} />
}
